import BriefHeroImage from './BriefHeroImage.jsx';
import BriefMasthead from './BriefMasthead.jsx';

/** Logo + issue line + hero image in one bordered white panel (newsletter v2 lead). */
export default function BriefLead({ model }) {
  const hasHero = Boolean(model.heroImage?.url);

  return (
    <div className="border border-black bg-white mb-10 sm:mb-12 overflow-hidden">
      <BriefMasthead model={model} showBottomRule={hasHero} />
      <BriefHeroImage heroImage={model.heroImage} embedded />
    </div>
  );
}
